let suf = "sites/";
export default {  
	get(){
		return suf+"get";
	},
	set(){
		return suf+"set";
	},
};
